import { render, staticRenderFns } from "./SCteProcuraPneu.vue?vue&type=template&id=6f00b20f"
import script from "./SCteProcuraPneu.vue?vue&type=script&lang=js"
export * from "./SCteProcuraPneu.vue?vue&type=script&lang=js"
import style0 from "./SCteProcuraPneu.vue?vue&type=style&index=0&id=6f00b20f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports